import { isCiap } from 'components/form/field/select/CiapCidSelectField/CiapCidSelectField'
import { AcompanhamentoCondicaoSaudeTematicaEnum } from 'graphql/types.generated'
import { isEmpty, isUndefinedOrNull } from 'util/checks'

import { AcompanhamentoCondicaoSaudeFormModel } from './model/model-acompanhamentoCondicaoSaude'

const selecaoTematicaAnalyticsEventNameByTematica: Record<AcompanhamentoCondicaoSaudeTematicaEnum, string> = {
  DESENVOLVIMENTO_INFANTIL: 'buscar_acomp_condicoes_saude_lista_des_infantil',
  DIABETES: 'buscar_acomp_condicoes_saude_lista_diabetes',
  GERAL: 'buscar_acomp_condicoes_saude_lista_geral',
  GESTANTE_PUERPERA: 'buscar_acomp_condicoes_saude_lista_gestacao_puerperio',
  HIPERTENSAO_ARTERIAL: 'buscar_acomp_condicoes_saude_lista_hipertensao',
  PESSOA_IDOSA: 'buscar_acomp_condicoes_saude_lista_pessoa_idosa',
  SAUDE_BUCAL: 'buscar_acomp_condicoes_saude_lista_saude_bucal',
  SAUDE_MULHER: 'buscar_acomp_condicoes_saude_lista_saude_mulher',
}

export function getAcompanhamentoCondicaoSaudeSubmitAnalyticsEvents(values: AcompanhamentoCondicaoSaudeFormModel) {
  const { filtrosAvancados = {}, tematica } = values ?? {}
  const { periodoUltimoAtendimento, problemasCondicoes, grupoCondicao, ativoListaProblema, ivcf } = filtrosAvancados

  const hasGrupoCondicao = !isEmpty(grupoCondicao)
  const hasCiap = problemasCondicoes?.some((item) => isCiap(item))
  const hasCid = problemasCondicoes?.some((item) => !isCiap(item))
  const hasIvcf = !isUndefinedOrNull(ivcf)
  const hasPeriodoUltimoAtendimento = !isUndefinedOrNull(
    periodoUltimoAtendimento?.startDate || periodoUltimoAtendimento?.endDate
  )

  const events: string[] = [selecaoTematicaAnalyticsEventNameByTematica[tematica]]

  if (hasGrupoCondicao) events.push('buscar_acomp_condicoes_saude_with_grupo_condicao')
  if (hasCiap) events.push('buscar_acomp_condicoes_saude_with_ciap')
  if (hasCid) events.push('buscar_acomp_condicoes_saude_with_cid')
  if (hasIvcf) events.push('buscar_acomp_condicoes_saude_with_ivcf')
  if (hasPeriodoUltimoAtendimento) events.push('buscar_acomp_condicoes_saude_with_periodo_ultimo_atend')

  events.push(
    ativoListaProblema
      ? 'buscar_acomp_condicoes_saude_with_condicoes_ativas'
      : 'buscar_acomp_condicoes_saude_with_condicoes_ativas_e_inativas'
  )

  return events
}
